<mat-card>
  <mat-card-content>
    <app-terms-display
      [type]="'parent'"
      [header]="'terms of service'"
      [skippable]="skippable"
      (submitted)="submit()"
      (skipped)="skip()">
    </app-terms-display>
  </mat-card-content>
</mat-card>